import {useFarm} from 'context/farmContext';
import {useEffect} from 'react';
import {useCookies} from 'react-cookie';
import {useNavigate} from 'react-router-dom';

const WithNotification = ({
  CultivationArea,
  subProduct,
  harvestDateTime,
  guid,
  mahsulGuid,
}: IWithNotificationProps) => {
  const [, , removeCookie] = useCookies(['cultivationGuid']);
  const navigate = useNavigate();
  const {updateCultivationGuid, updateCultivationArea} = useFarm();
  useEffect(() => {
    updateCultivationGuid(guid, subProduct);
    updateCultivationArea({
      area: CultivationArea,
      harvest_datetime: harvestDateTime,
    });
    subProduct === null
      ? navigate('/farm/add-ad/sub-product', {
          state: {
            product: mahsulGuid,
            guid: guid,
          },
        })
      : navigate('/farm/add-ad/type-ads', {
          state: {
            cultivationGuid: guid,
          },
        });
    removeCookie('cultivationGuid');
  }, [
    CultivationArea,
    subProduct,
    harvestDateTime,
    guid,
    mahsulGuid,
    navigate,
    updateCultivationGuid,
    updateCultivationArea,
    removeCookie,
  ]);
  return <></>;
};

export default WithNotification;
